import React from 'react';
import dayjs from 'dayjs';
import styles from './ApprovalStamp.module.scss';

interface ApprovalStampProps {
  approvedAt: string;
}

export const ApprovalStamp: React.FC<ApprovalStampProps> = ({ approvedAt }) => {
  const formatApprovalDate = (dateString: string) => {
    return dayjs(dateString).format('DD/MM/YYYY [at] h:mm A');
  };

  return (
    <div className={styles.approvalStamp} data-testid="approval-stamp">
      You approved this version on {formatApprovalDate(approvedAt)}
    </div>
  );
};
